import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'
import { Container } from 'react-bootstrap'

export const Page = () => {
  return (
    <Provider>
      <Container>
        <Layout />
      </Container>
    </Provider>
  )
}
